import { render, staticRenderFns } from "./ZimmerreservationFormular.vue?vue&type=template&id=b86c5c48"
import script from "./ZimmerreservationFormular.vue?vue&type=script&lang=js"
export * from "./ZimmerreservationFormular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports